import type { IReport, IReporter } from '@/lib/interface.ts';

export type TReportSource = 'all' | 'member' | 'automatic' | 'refund';

export const REPORT_SOURCES: { value: TReportSource; title: string }[] = [
	{ value: 'all', title: 'Tous' },
	{ value: 'member', title: 'Membres' },
	{ value: 'automatic', title: 'Automatiques (IA)' },
	{ value: 'refund', title: 'Remboursements' }
];

const sourceOf = (reporter: IReporter): TReportSource => reporter.source ?? 'member';

/* A report can hold several reporters: only those of the chosen source are shown */
export const reportsOfSource = (reports: IReport[], source: TReportSource): IReport[] =>
	source === 'all'
		? reports
		: reports
				.map(report => ({ ...report, reporters: report.reporters.filter(reporter => sourceOf(reporter) === source) }))
				.filter(report => report.reporters.length > 0);
